'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ParamService = exports.ParamService = function () {
    function ParamService(winresCloudService, $q) {
        _classCallCheck(this, ParamService);

        this.winresCloudService = winresCloudService;
        this.$q = $q;
        this.promises = {};
    }

    _createClass(ParamService, [{
        key: 'getWinresParam',
        value: function getWinresParam(param) {
            var _this = this;

            // Return simulanteous promise instead of 
            // doing a new GET request.
            if (this.promises[param] !== undefined && this.promises[param].$$state.pending) {
                return this.promises[param];
            }

            var endpoint = 'Winres/x/Params/' + param;

            this.promises[param] = this.$q(function (resolve) {
                _this.winresCloudService.get(endpoint).then(function (winresParam) {
                    resolve(winresParam.data);
                });
            });

            return this.promises[param];
        }
    }]);

    return ParamService;
}();

ParamService.$inject = ['winresCloudService', '$q'];


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/paramService.js
// module id = 667
// module chunks = 2